import { ReactNode } from "react";

import * as S from "./styled";

type AdminPageProps = {
  title: string;
  headerControls?: ReactNode;
  children: ReactNode;
};

/**
 * Standard layout shared by all views in the admin view: a heading with the
 * page title and optional controls on the right, followed by padded content.
 */
export const AdminPage = ({
  title,
  headerControls,
  children,
}: AdminPageProps) => (
  <>
    <S.HeadingContainer>
      <h1>{title}</h1>
      {headerControls}
    </S.HeadingContainer>
    <S.AdminContent>{children}</S.AdminContent>
  </>
);
